import React, { useEffect, useState, useRef } from "react";
import { motion, useScroll, useTransform, AnimatePresence } from "framer-motion";

const servicesIcons = [
  "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783592526/Ai_Studio_tgnlgx.png",
  "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783592530/Branding_plf11j.png",
  "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783592569/Business_Email_gjtym7.png",
  "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783592571/Cloud_Hosting_r4dhnw.png",
  "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783592595/Cloud_Infrastructure_lc95wd.png",
  "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783592598/Digital_Consulting_omfwle.png",
  "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783592631/Domain_Registration_yepdwe.png",
  "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783592647/Managed_Hosting_xvd62v.png",
  "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783592657/SEO_Services_fjwtuo.png",
  "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783592672/Webiste_Developement_imxd2u.png",
  "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783592688/Website_Maintenance_u0auky.png",
  "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783592702/Website_Migration_jrlmnu.png"
];

const ServiceIconNode = ({ i, activeGroup, expandRadius, orbitRotationRad, iconBaseOpacity }) => {
  const iconIndex = i + (activeGroup * 6);
  const currentSrc = servicesIcons[iconIndex];

  const x = useTransform([expandRadius, orbitRotationRad], ([r, rot]) => {
    const angle = (i * 2 * Math.PI) / 6 + rot;
    return r * Math.cos(angle);
  });
  const y = useTransform([expandRadius, orbitRotationRad], ([r, rot]) => {
    const angle = (i * 2 * Math.PI) / 6 + rot;
    return r * Math.sin(angle);
  });

  return (
    <motion.div style={{ x, y, opacity: iconBaseOpacity }} className="absolute w-24 h-24 rounded-2xl overflow-hidden border-[6px] border-white shadow-xl z-10 flex items-center justify-center bg-slate-50 p-4" >
      <AnimatePresence mode="wait">
        <motion.img key={currentSrc} src={currentSrc} alt={`Service ${iconIndex + 1}`} initial={{ opacity: 0, scale: 0.5 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.5 }} transition={{ duration: 0.4 }} className="w-full h-full object-contain absolute" />
      </AnimatePresence>
    </motion.div>
  );
};

const ServicesGrid = () => {
  const containerRef = useRef(null);
  const [activeGroup, setActiveGroup] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveGroup((prev) => (prev === 0 ? 1 : 0));
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  const { scrollYProgress } = useScroll({ target: containerRef, offset: ["start start", "end end"] });
  const expandRadius = useTransform(scrollYProgress, [0, 1], [0, 320]);
  const orbitRotationRad = useTransform(scrollYProgress, [0, 1], [0, 2 * Math.PI]);
  const outerRingOpacity = useTransform(scrollYProgress, [0.4, 0.5], [0, 1]);
  const middleRingOpacity = useTransform(scrollYProgress, [0.2, 0.3], [0, 1]);
  const contentOpacity = useTransform(scrollYProgress, [0.3, 0.4], [0, 1]);
  const iconBaseOpacity = useTransform(scrollYProgress, [0.05, 0.1], [0, 1]);

  return (
    <section ref={containerRef} className="relative h-[250vh] bg-slate-50">
      <div className="sticky top-0 h-screen flex items-center justify-center overflow-hidden">
        <div className="relative flex items-center justify-center scale-50 sm:scale-75 lg:scale-100 origin-center">
          <motion.div style={{ opacity: outerRingOpacity }} className="absolute w-[800px] h-[800px] rounded-full border border-slate-200" />
          <motion.div style={{ opacity: middleRingOpacity }} className="absolute w-[600px] h-[600px] rounded-full border border-blue-200" />
          <div className="absolute w-[400px] h-[400px] rounded-full bg-gradient-to-r from-blue-400 via-blue-500 to-indigo-600 p-[3px] flex items-center justify-center shadow-2xl">
            <div className="w-full h-full rounded-full bg-white flex flex-col items-center justify-center relative shadow-inner">
              {[0, 1, 2, 3, 4, 5].map((i) => (
                <ServiceIconNode key={i} i={i} activeGroup={activeGroup} expandRadius={expandRadius} orbitRotationRad={orbitRotationRad} iconBaseOpacity={iconBaseOpacity} />
              ))}
              <motion.div style={{ opacity: contentOpacity }} className="flex flex-col items-center justify-center relative z-20 px-8" >
                <img src="https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783586850/No_Backgournd_just_logo_pl2cm4.png" alt="HostFig Logo" className="h-16 md:h-24 mb-6 object-contain" />
                <h1 className="text-3xl md:text-5xl font-bold text-slate-900 text-center mb-4 tracking-tight leading-none"> Our Services </h1>
                <p className="text-slate-500 text-sm md:text-base text-center max-w-[260px] leading-relaxed"> Everything you need to build, host and grow your digital presence. </p>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;